import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/business/leads/companies/$companyId")({
    beforeLoad: ({ params, search }) => {
        throw redirect({ to: "/sales/leads/companies/$companyId", params, search, replace: true });
    },
});
